import {
  computed,
  Injectable,
  resource,
  ResourceLoaderParams,
  ResourceRef,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { IPaymentPreference } from '@web/dtos';
import { IApiResponse } from '@web/shared-types';
import { firstValueFrom } from 'rxjs';
import { PaymentPreferenceGateway } from './payment-preference.gateway';

@Injectable({
  providedIn: 'root',
})
export class PaymentPreferenceStore {
  private readonly gateway: PaymentPreferenceGateway =
    new PaymentPreferenceGateway();
  private readonly userId: WritableSignal<string> = signal('');

  #paymentPreferenceResource: ResourceRef<
    IApiResponse<IPaymentPreference> | undefined
  > = resource({
    params: this.userId,
    loader: ({
      params,
    }: ResourceLoaderParams<string>): Promise<
      IApiResponse<IPaymentPreference> | undefined
    > => {
      return params
        ? firstValueFrom(this.gateway.get(params))
        : Promise.resolve(undefined);
    },
  });

  readonly isLoading: Signal<boolean> = computed((): boolean =>
    this.#paymentPreferenceResource.isLoading()
  );
  readonly paymentPreference: Signal<IPaymentPreference | undefined> = computed(
    (): IPaymentPreference | undefined =>
      this.#paymentPreferenceResource.hasValue()
        ? this.#paymentPreferenceResource.value()?.data
        : undefined
  );

  loadPreference(userId: string) {
    this.userId.set(userId);
  }

  updatePreference(paymentPreference: IPaymentPreference) {
    firstValueFrom(this.gateway.save(paymentPreference)).then(() => {
      this.reload();
    });
  }

  reload(): void {
    this.#paymentPreferenceResource.reload();
  }
}
